<template>
  <section>
    <div class="top">
      <div class="allTitle" style="fontSize:18px;margin-left:30px;width: 100%;">
        数据统计
      </div>
      <div class="tabs">
        <div
            class="item"
            style="background: linear-gradient(48deg,#a87aff 6%, #7151ed 93%);"
        >
          <div class="status">
            <!-- <i class="el-icon-edit"></i> -->
            待处理工单
          </div>
          <div class="nums">
            <span class="num1">{{ data.orderAcceptedCount }}</span>
            <span class="num2">{{ "/" + data.orderAllCount }}</span>
          </div>
        </div>
        <div
            class="item"
            style="background: linear-gradient(48deg,#7a81ff, #6345ff 89%);"
        >
          <div class="status">
            已处理工单
          </div>
          <div class="nums">
            <span class="num1">{{ data.orderWaitingCount }}</span>
            <span class="num2">{{ "/" + data.orderAllCount }}</span>
          </div>
        </div>
        <div
            class="item"
            style="background: linear-gradient(46deg,#5c8bff, #0095ff 93%);"
        >
          <div class="status">
            已关闭工单
          </div>
          <div class="nums">
            <span class="num1">{{ data.orderClosedCount }}</span>
            <span class="num2">{{ "/" + data.orderAllCount }}</span>
          </div>
        </div>
        <div
            class="item"
            style="background: linear-gradient(51deg,#5c8bff 4%, #356df9 95%);"
        >
          <div class="status">
            处理中的工单
          </div>
          <div class="nums">
            <span class="num1">{{ data.orderProcessingCount }}</span>
            <span class="num2">{{ "/" + data.orderAllCount }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- echarts -->
    <div class="bottom">
      <div class="allTitle" style="fontSize:18px;margin-left:30px">
        事件分析
      </div>
      <!-- <div class="allTitle" style="fontSize:18px;margin-left:30px">
                <span>事件分析</span>
                <el-radio-group v-model="dayType" style="float:right;margin-right:330px" @change="dayTpeChange">
                    <el-radio-button label="1">年</el-radio-button>
                    <el-radio-button label="2">月</el-radio-button>
                    <el-radio-button label="3">日</el-radio-button>
                </el-radio-group>
            </div> -->
      <div class="echart">
        <div id="myChart" :style="{ width: '1240px', height: '429px' }"></div>
      </div>
    </div>
  </section>
</template>
<script>
import api from "plus/api";
import echarts from "echarts";
import {scrollTo} from "@/utils/scroll-to";

export default {
  data() {
    return {
      year: "",
      dayType: "1",
      orderAcceptedYearCount: [],
      orderClosedYearCount: [], //已关闭
      orderProcessingYearCount: [], //驳回
      orderWaitingYearCount: [], //待处理
      data: {},
    };
  },
  watch: {},
  activated() {
    scrollTo(0, 0);
    this.drawLine();
  },
  deactivated() {
  },
  computed: {},
  created() {
    this.getData();
    this.getYear();
  },
  methods: {
    getYear() {
      let date = new Date();
      this.year = date.getFullYear();
    },
    getData() {
    },
    drawLine() {
      api.work.getWorkIndexPagefilters(1).then((res) => {
        this.data = res.data.data;
        this.orderAcceptedYearCount = Object.values(
            res.data.data.orderAcceptedYearCount
        );
        this.orderClosedYearCount = Object.values(
            res.data.data.orderClosedYearCount
        );
        this.orderProcessingYearCount = Object.values(
            res.data.data.orderProcessingYearCount
        );
        this.orderWaitingYearCount = Object.values(
            res.data.data.orderWaitingYearCount
        );
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById("myChart"));
        // 绘制图表
        myChart.setOption({
          color: ["#67c23a", "#409eff", "#9271ff", "yellow", "pink"],
          title: {
            text: `${this.year}年工单处理趋势分析`,
            top: 10,
            left: 30,
            textStyle: {
              fontWeight: 700,
              color: "#666666",
              fontSize: 14,
            },
          },
          tooltip: {},
          legend: {
            data: ["待处理", "已处理", "已关闭", "处理中"],
            bottom: 0,
          },

          xAxis: {
            boundaryGap: false,
            data: [
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
              "九月",
              "十月",
              "十一月",
              "十二月",
            ],
          },
          yAxis: {
            axisLine: {
              //y轴
              show: false,
            },
            axisTick: {
              //y轴刻度线
              show: false,
            },
            // show : false,
          },
          series: [
            {
              lineStyle: {
                normal: {
                  width: 1,
                },
              },
              name: "待处理",
              type: "line",
              smooth: true,
              data: this.orderAcceptedYearCount,
            },
            {
              lineStyle: {
                normal: {
                  width: 1,
                },
              },
              name: "已处理",
              type: "line",
              smooth: true,
              data: this.orderWaitingYearCount,
            },
            {
              lineStyle: {
                normal: {
                  width: 1,
                },
              },
              name: "已关闭",
              type: "line",
              smooth: true,
              data: this.orderClosedYearCount,
            },
            {
              lineStyle: {
                normal: {
                  width: 1,
                },
              },
              name: "处理中",
              type: "line",
              smooth: true,
              data: this.orderProcessingYearCount,
            },
          ],
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
#myChart {
  left: 50%;
  transform: translate(-50%);
}

.work-index-wap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.bottom {
  width: 1661px;
  height: 490px;
  background-color: white;
  padding-top: 30px;
  // .allTitle{
  //     position: absolute;
  //     left: -640px;
  //     width: 100%;
  //     font-size: 18px;
  //     font-family: Helvetica;
  //     text-align: center;
  //     color: #333333;
  //     line-height: 22px;
  //     margin-top: 34px;
  // }
  .allTitle::before {
    margin-right: 8px;
    content: "";
    border-left: 4px solid #3572e2;
    height: 16px;
  }
}

.echart {
  margin-top: 20px;
}

.top {
  background-color: white;
  height: 258px;
  width: 100%;
  padding-top: 30px;
  margin-bottom: 30px;

  .allTitle::before {
    margin-right: 8px;
    content: "";
    border-left: 4px solid #3572e2;
    height: 16px;
  }

  background-color: white;
  height: 258px;
  width: 1662px;

  .tabs {
    margin-top: 23px;
    display: flex;
    justify-content: center;
    align-items: center;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffff;
      flex-direction: column;
      border-radius: 8px;
      width: 370px;
      height: 154px;
      margin-left: 33px;

      .nums {
        .num1 {
          font-size: 36px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 50px;
        }

        .num2 {
          font-size: 12px;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 17px;
        }
      }

      .status {
        font-size: 20px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 28px;
      }
    }
  }
}
</style>
